<a [routerLink]="hrefLink()" [fragment]="fragment()">
  <h4 class="cursor-pointer">{{title()}}
    <span class="float-right pt-1"><mat-icon>chevron_right</mat-icon></span>
  </h4>
  <div class="grid grid-cols-[38%_17%_10%_35%] cursor-pointer app-card-content w-full md:text-sm text-xs">
  <ng-content></ng-content>
</div>
</a>
